export enum CompleteI9PageTranslation {
    i9Section2Heading = 'i9Section2Heading',
    i9Section2Subtitle = 'i9Section2Subtitle',
    esignButton = 'esignButton',
    declineButton = 'declineButton',
    backButton = 'backButton',
    uscisDescription = 'uscisDescription',
    section2Description = 'section2Description',
    stepInstruction = 'stepInstruction',
    certification = 'certification',
    employeeFirstEmploymentDateLabel = 'employeeFirstEmploymentDateLabel',
    employeeFirstEmploymentDateExemptionHint = 'employeeFirstEmploymentDateExemptionHint',
    additionalInformation = 'additionalInformation',
    documentsPhysicallyExaminedLabel = 'documentsPhysicallyExaminedLabel',
    qrCodeSection2And3Line1 = 'qrCodeSection2And3Line1',
    qrCodeSection2And3Line2 = 'qrCodeSection2And3Line2',
    eSignatureByProvidingSignature = 'eSignatureByProvidingSignature',
    eSignatureLine1 = 'eSignatureLine1',
    eSignatureLine2 = 'eSignatureLine2',
    eSignatureLine3 = 'eSignatureLine3',
    documentNumberInvalidWithExampleTemplate = 'documentNumberInvalidWithExampleTemplate',
    documentNumberInvalidSSNMismatch = 'documentNumberInvalidSSNMismatch',
    documentNumberInvalidSSNPattern = 'documentNumberInvalidSSNPattern',
    receiptReplacementTitle = 'receiptReplacementTitle'
}



// WEBPACK FOOTER //
// ./src/screens/review-section2/complete-i9/complete-i9-page-translation.ts